import React,{useState, useEffect, useRef} from "react";
import moment from 'moment';
import axios from '../../../plugins/axios'
import { mmHgToKPa, celsiusToFahrenheit, percentTommHg,percentToKpa,mmHgToPercent } from '../../../plugins/common'
import { useRecoilState } from 'recoil';
import { selectBedInfoState,unitState } from '../../../plugins/recoil';
import { useTranslation } from 'react-i18next'

const Tabular = ({deviceInfo,startTime,endTime,selectTime}) => {
    const { t } = useTranslation()
    const isFirstRender = useRef(true);    
    const [detailData, setDetailData] = useState({
            timestampstr: [],
        })
    const [detailDataKeys, setDetailDataKeys] = useState([])
    const [units, setUnits] = useRecoilState(unitState)
    const isSelected = (targetTimeString) => {
        if (!selectTime) return false         
        if (moment.utc(selectTime).format('HH:mm:ss') === targetTimeString) return true
        return false
    }

    //API에서 날라오는 파라미터 네이밍 재 변환을 위한 정리.
    const TrendType = {
        "hr" : "HR/PR",
        "arrhythmia" : "arrhythmia",
        "spo2Percent" : "SpO2",
        "rrRpm" : "RR",
        "temp1C" : "Temp1",
        "temp2C" : "Temp2",
        "awrrRpm" : "awRR",
        "ibp1" : "IBP 1",
        "ibp2" : "IBP 2",
        "ibp3" : "IBP 3",
        "ibp4" : "IBP 4",
        "nibp" : "NIBP",     
        "gasCo2" : "Gas CO2",
        "gasDes" : "Gas DES",
        "gasN2o" : "Gas N2O",
        "gasO2" : "Gas O2",
        "gasSev" : "Gas SEV",
        "etCo2" : "EtCO2",
        "inCo2" : "InCO2",
        "ipi" : "IPI",   
    }

    //API에서 넘어오는 파라미터 정리.
    const UnitType = {
        "hr" : "HR",
        "arrhythmia" : "arrhythmia",
        "spo2Percent" : "SpO2",
        "rrRpm" : "RR",
        "temp1C" : "Temp1",
        "temp2C" : "Temp2",
        "awrrRpm" : "awRR",
        "ibp1" : "IBP1",
        "ibp2" : "IBP2",
        "ibp3" : "IBP3",
        "ibp4" : "IBP4",
        "nibp" : "NIBP",
        "gasCo2" : "gasCo2",
        "gasDes" : "gasDes",
        "gasN2o" : "gasN2o",
        "gasO2" : "gasO2",
        "gasSev" : "gasSev",
        "etCo2" : "EtCO2",
        "inCo2" : "InCO2",
        "ipi" : "IPI",
    }

    // Unit 재 세팅
    const getUnits = async () => {
        try{
            const unitRes = await axios.get(`/measure/parameter/categories`)
            if (unitRes.code != '200') throw unitRes
            // console.log('unitRes : ',unitRes);
            setUnitInfo(unitRes.data.categories)
        }
        catch(err){
            console.warn(err)
        }
    }

    //Unit 세팅
    const setUnitInfo = (categories) => {
        if (!categories) return
        let nibpUnit = categories.find(category => category.name === 'NIBP')
        nibpUnit = nibpUnit.unit || nibpUnit.defaultUnit

        let ibpUnit = categories.find(category => category.name === 'IBP')
        ibpUnit = ibpUnit.unit || ibpUnit.defaultUnit

        let co2Unit = categories.find(category => category.name === 'CO2')
        co2Unit = co2Unit.unit || co2Unit.defaultUnit

        let tempUnit = categories.find(category => category.name === 'TEMP')
        tempUnit = tempUnit.unit || tempUnit.defaultUnit

        let gasUnit = categories.find(category => category.name === 'GAS')
        gasUnit = gasUnit.unit || gasUnit.defaultUnit

        setUnits({
            ...units,
            'NIBP': nibpUnit,
            'IBP': ibpUnit,
            'IBP1': ibpUnit,
            'IBP2': ibpUnit,
            'IBP3': ibpUnit,
            'IBP4': ibpUnit,
            'EtCO2': co2Unit,
            'InCO2': co2Unit,
            'Temp': tempUnit,
            'Temp1': tempUnit,
            'Temp2': tempUnit,
            'GAS': gasUnit
        })
    }

    // Tabular 데이터 가져오기
    const getTabularTrendData = async () => {
        try{
            const res = await axios.get(`/trend/tabular/vitals?serialNo=${deviceInfo?.serial}&startTime=${moment.utc(startTime).format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment.utc(endTime).format('YYYY-MM-DDTHH:mm:ss')}Z`);
            const data = res.data.data;
            
            if(data.length > 0){
                setDetailData(data)
                setDetailDataKeys(Object.keys(data[0]).filter(keyName => keyName != "timestamp" && keyName != "patientId" && keyName != "patientName"))                               
            }else{
                setDetailData([])
                setDetailDataKeys([])                
            }
        }
        catch(err){
            console.warn('getTabularTrendData error:', err);
        }
    }

    // 단위 변환 함수
    const convertUnit = (parameter,value) => {
        const nibpSeries = ['NIBP']
        const ibpSeries = ['IBP1', 'IBP2', 'IBP3', 'IBP4']
        const co2Series = ['EtCO2', 'InCO2']
        const tempSeries = ['Temp1', 'Temp2']        
        const gasSeries = ['gasCo2', 'gasDes', 'gasN2o', 'gasO2', 'gasSev']
        const otherSeries = ['HR', 'RR', 'awRR', 'SpO2', 'arrhythmia', 'IPI']

            //함수를 유동적으로 사용해보고 싶어서 써봄.
        const convertFunctions = {
            mmHgToKPa,
            celsiusToFahrenheit,
            percentTommHg,
            percentToKpa,
            mmHgToPercent
        };

        let unit = undefined;
        let functionName = undefined;                

        if (nibpSeries.includes(parameter)) {
            unit = units["NIBP"];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
        } else if (ibpSeries.includes(parameter)) {
            const prefix = parameter.match(/^IBP[1-4]/)?.[0];  // "IBP1", "IBP2" 등 추출
            unit = units[prefix];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
        } else if (co2Series.includes(parameter)) {
            unit = units[parameter];            
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
            else if(unit === '%'){
                functionName = 'mmHgToPercent'; // mmHg를 %로 변환하는 함수
            }
        } else if (tempSeries.includes(parameter)) {
            unit = units[parameter];
            if(unit === '°F') {
                functionName = 'celsiusToFahrenheit'; // 섭씨를 화씨로 변환하는 함수
            }
        } 
        else if (gasSeries.includes(parameter)) {            
            unit = units["GAS"];            
            if(unit === 'mmHg') {
                functionName = 'percentTommHg'; // mmHg를 kPa로 변환하는 함수
            }
            else if(unit === 'kPa'){
                functionName = 'percentToKpa';
            }
        } else if(otherSeries.includes(parameter)) {
            unit = units[parameter];
        }

        let label = value;
        if (functionName && typeof convertFunctions[functionName] === 'function') {
            if(nibpSeries.includes(parameter) || ibpSeries.includes(parameter) || gasSeries.includes(parameter)){
                const splitValue = value.split('/');
                let newLabel = '';
                splitValue.map((value,index) => {
                    const convertedValue = value === '-' ? '-' : String(convertFunctions[functionName](value));
                    newLabel += convertedValue + `${index == splitValue.length - 1 ? '' : '/'}`;     
                })
                label = newLabel;
            }else {
                label = convertFunctions[functionName](value);
            }
        }
        return label;
    }

    useEffect(() => {
        if(units){
            getTabularTrendData();
        }
    }, [units])    

    useEffect(() => {
        getUnits();
    }, [])

    const titleFontBold = 'text-black font-medium text-[48px] leading-[110%] font-pretendard';
    const subTitleFont = 'text-black font-thin text-[36px] leading-[40px] font-pretendard';
    const tableHeaderFont = 'text-black text-center font-pretendard text-[28px] font-medium leading-[110%] bg-[#fff] py-[24px]';
    const tableBodyFont = 'text-black text-center font-pretendard text-[32px] font-light leading-[110%] py-[15px] whitespace-nowrap';
    const tableLine = 'border-b-[1px] border-opacity-50 border-[#5E5E5E]';

    return (
        <div className="a4-page-landscape mx-auto bg-white shadow-lg relative box-border">
            <div className="w-full h-full flex flex-col px-[146px] pt-[140px] pb-[66px]">                
                {/* Header */}
                <div className="w-full flex items-center justify-start pb-[24px] border-b-[4px] border-[#5E5E5E]">
                    <div className="flex items-center justify-center gap-[20px]">
                        <strong className={titleFontBold}>
                            {t("print.trendForm.tabularTrend")}
                        </strong>
                        <strong className={subTitleFont}>
                            ( *{t("print.trendForm.alarmSituation")} )
                        </strong>
                    </div>
                </div>    

                {/* Content */}
                <div className="w-full relative mb-[40px]">
                    <div className="w-full flex flex-col">                                            
                        <div className="w-full flex items-center justify-between flex-wrap">
                            <div title="Table" className="w-full flex flex-col justify-center items-center">
                                <table className="w-full">
                                    <thead>
                                        <tr className={`${tableLine}`}>
                                        <th className={`${tableHeaderFont} text-left`}>Time</th>
                                        {detailDataKeys.map((keyName, idx) => (
                                            <th className={`${tableHeaderFont} text-left`} key={`tabular-header-${idx}`}>
                                                <strong>{TrendType[keyName] || keyName}</strong>
                                                {/* {units[UnitType[keyName]] && (
                                                    <p className="text-[#848484] font-pretendard text-[24px] font-medium leading-[140%]">
                                                    ({units[UnitType[keyName]]})
                                                    </p>
                                                )} */}
                                                {['gasCo2', 'gasDes', 'gasN2o', 'gasO2', 'gasSev'].includes(keyName)
                                                    ? (units['GAS'] && (
                                                        <p className="text-[#848484] font-pretendard text-[24px] font-medium leading-[140%]">
                                                            ({units['GAS']})
                                                        </p>
                                                    ))
                                                    : (units[UnitType[keyName]] && (
                                                        <p className="text-[#848484] font-pretendard text-[24px] font-medium leading-[140%]">
                                                            ({units[UnitType[keyName]]})
                                                        </p>
                                                    ))
                                                }
                                            </th>
                                        ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detailDataKeys.length > 0 ? (
                                            detailData.map((item, index) => (
                                                <tr key={index} className={`${tableLine}`}>
                                                <td className={`${tableBodyFont} ${isSelected(moment(item.timestamp).format('HH:mm:ss')) ? 'border-[4px] border-dotted border-[#000]' : ''}`}>
                                                    {moment(item.timestamp).format('HH:mm:ss')}
                                                </td>
                                                {detailDataKeys.map((keyName, keyDataIdx) => {
                                                    const keyDetailData = item[keyName].value;
                                                    const keyDetailAlarm = item[keyName].priority;
                                                    return (
                                                    <td
                                                        key={`trend-review-data-${item}-${keyName}-${keyDataIdx}`}
                                                        className={`${tableBodyFont}`}
                                                    >
                                                        {keyDetailData != '-' ? convertUnit(UnitType[keyName], keyDetailData) : '---'}
                                                        {keyDetailData != '-' && (keyDetailAlarm == 0 || keyDetailAlarm == 1 || keyDetailAlarm == 2) ? '＊' : ''}
                                                    </td>
                                                    );
                                                })}
                                                </tr>
                                            ))
                                            ) : (
                                            <tr>
                                                <td colSpan={detailDataKeys.length + 1}>No Data Available</td>
                                            </tr>
                                            )}
                                    </tbody>
                                </table>
                              </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="w-full flex items-center justify-end">
                    <div>
                        <span className="text-black text-center font-pretendard text-[24px] font-medium leading-[110%]">
                            (2/2)
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tabular;
